import { render, staticRenderFns } from "./khRegistrationAgreement.vue?vue&type=template&id=d69c0b26&scoped=true"
import script from "./khRegistrationAgreement.vue?vue&type=script&lang=js"
export * from "./khRegistrationAgreement.vue?vue&type=script&lang=js"
import style0 from "./khRegistrationAgreement.vue?vue&type=style&index=0&id=d69c0b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69c0b26",
  null
  
)

export default component.exports